import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './ProductDetails.css';
import { Footer } from '../../Components';

function ProductDetails() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch the product data based on the ID
    const fetchProduct = async () => {
        const productsData = [
            {
                id: 1,
                name: 'Classic Pomade',
                price: 19.99,
                description: 'A medium-hold pomade for a sleek, classic look.',
                descriptionDetail: 'This Classic Pomade is perfect for those who want a timeless, polished style. With a medium hold and added shine, it works well for all hair types and can be easily washed out. Infused with nourishing ingredients, it keeps your hair healthy and hydrated throughout the day without feeling greasy or heavy.',
                image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865'
            },
            {
                id: 2,
                name: 'Beard Oil',
                price: 14.99,
                description: 'Condition and soften your beard with natural oils.',
                descriptionDetail: 'Our Beard Oil is crafted with a blend of high-quality natural oils that not only soften and condition your beard but also moisturize the skin underneath. This helps to prevent itchiness, dryness, and flakiness, leaving your beard soft, shiny, and healthy. The oil absorbs quickly without a greasy residue, making it suitable for daily use.',
                image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865'
            },
            {
                id: 3,
                name: 'Hair Clipper',
                price: 99.99,
                description: 'Professional-grade clipper with adjustable settings.',
                descriptionDetail: 'This professional-grade hair clipper features adjustable settings for a customizable cut and precise control. It is equipped with a high-power motor for durability and performance, and its ergonomic design makes it comfortable to hold. Perfect for both home use and professional barber shops, this clipper ensures a smooth, clean cut every time.',
                image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865'
            },
            {
                id: 4,
                name: 'Straight Razor',
                price: 29.99,
                description: 'Achieve a close shave with this stainless steel razor.',
                descriptionDetail: 'The Straight Razor is crafted from high-quality stainless steel, ensuring sharpness and durability. It delivers a close, smooth shave, making it a favorite among barbers and grooming enthusiasts. The blade is designed to glide effortlessly, minimizing irritation and providing a traditional, refined shaving experience.',
                image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865'
            },
            {
                id: 5,
                name: 'Beard Balm',
                price: 16.99,
                description: 'Control frizz and shape your beard with ease.',
                descriptionDetail: 'Our Beard Balm is perfect for taming frizz and shaping your beard. It provides a light hold and leaves a matte finish, enhancing the natural look of your beard. Enriched with vitamins and essential oils, it conditions and strengthens your beard, making it soft, manageable, and healthy-looking.',
                image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865'
            },
            {
                id: 6,
                name: 'Shaving Brush',
                price: 12.99,
                description: 'Lather up with this soft, high-quality brush.',
                descriptionDetail: 'This Shaving Brush is made with soft bristles that create a rich, creamy lather, ensuring a smooth and comfortable shave. The brush helps exfoliate the skin and lift hair, reducing irritation and promoting a closer shave. Its ergonomic handle makes it easy to hold, providing a luxurious shaving experience.',
                image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865'
            },
            {
                id: 7,
                name: 'Aftershave Lotion',
                price: 9.99,
                description: 'Soothing aftershave with a refreshing scent.',
                descriptionDetail: 'Our Aftershave Lotion soothes and calms your skin post-shave, reducing irritation and leaving your skin feeling refreshed. Infused with a light fragrance, it provides a pleasant scent that lasts throughout the day. The formula is lightweight and absorbs quickly without leaving a sticky residue.',
                image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865'
            },
            {
                id: 8,
                name: 'Hair Styling Gel',
                price: 10.99,
                description: 'Strong hold for all-day styling without residue.',
                descriptionDetail: 'This Hair Styling Gel provides a strong hold that lasts all day without leaving any sticky residue. It offers excellent control for a variety of hairstyles, from sleek looks to messy styles. Formulated with nourishing ingredients, it also helps to maintain the health of your hair while giving it a natural shine.',
                image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865'
            },
            {
                id: 9,
                name: 'Texturizing Powder',
                price: 15.99,
                description: 'Add volume and texture to any hairstyle.',
                descriptionDetail: 'Our Texturizing Powder is designed to give your hair added volume and texture without weighing it down. This lightweight formula absorbs excess oil and provides a matte finish, making it perfect for achieving that effortlessly tousled look. It’s suitable for all hair types and easy to apply.',
                image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865'
            },
            {
                id: 10,
                name: 'Scissors Set',
                price: 59.99,
                description: 'Professional-grade scissors for precise cuts.',
                descriptionDetail: 'This Scissors Set includes high-quality shears designed for precise cutting and shaping. Perfect for professional barbers and stylists, these scissors feature sharp, durable blades and an ergonomic design for comfortable use. The set is essential for creating detailed hairstyles and achieving clean lines.',
                image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865'
            },
            {
                id: 11,
                name: 'Beard Comb',
                price: 8.99,
                description: 'Tame and style your beard with ease.',
                descriptionDetail: 'Our Beard Comb is designed to glide smoothly through your facial hair, helping to detangle and style with ease. Made from high-quality materials, it prevents static and promotes healthy growth. Compact and portable, it’s perfect for grooming at home or on the go.',
                image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865'
            },
            {
                id: 12,
                name: 'Shaving Cream',
                price: 11.99,
                description: 'Rich, creamy lather for a smooth shave.',
                descriptionDetail: 'This Shaving Cream creates a rich, creamy lather that provides a smooth surface for shaving. Its moisturizing formula softens facial hair and protects your skin from irritation, ensuring a comfortable shave. Suitable for all skin types, it rinses easily and leaves your skin feeling refreshed.',
                image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865'
            },
            {
                id: 13,
                name: 'Hot Towel Warmer',
                price: 129.99,
                description: 'Give clients a luxurious experience with warm towels.',
                descriptionDetail: 'Our Hot Towel Warmer is perfect for creating a luxurious experience for your clients. This unit heats towels quickly and evenly, ensuring they are warm and ready for use. Ideal for barbershops and salons, it enhances the grooming experience and adds a touch of elegance to any service.',
                image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865'
            },
            {
                id: 14,
                name: 'Neck Duster Brush',
                price: 7.99,
                description: 'Remove loose hair after a fresh cut.',
                descriptionDetail: 'The Neck Duster Brush is designed to gently remove loose hair from your neck and shoulders after a haircut. With soft bristles that feel comfortable on the skin, it ensures a clean finish while providing a soothing experience. Compact and easy to handle, it’s a must-have tool for any barber.',
                image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865'
            },
            {
                id: 15,
                name: 'Barber Cape',
                price: 19.99,
                description: 'Protect clients clothes with this waterproof cape.',
                descriptionDetail: 'Our Barber Cape is made from waterproof material to protect your clients’ clothes from hair clippings and product spills. It features an adjustable neck strap for a comfortable fit and is lightweight for ease of movement. Ideal for barbershops and salons, this cape is a practical addition to any grooming setup.',
                image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865'
            },
        ];
        
        
      const foundProduct = productsData.find((p) => p.id === parseInt(id));
      setProduct(foundProduct);
    };
    fetchProduct();
  }, [id]);

  if (!product) {
    return <p>Loading product details...</p>;
  }

  return (
    <>
    <div className="product-details">
    <div className="product-image">
      <img src={product.image} alt={product.name} />
    </div>
    <div className="product-info">
      <h2 className="product-name">{product.name}</h2>
      <p className="product-price">${product.price.toFixed(2)}</p>
      <p className="product-description">{product.description}</p>
      <p className="product-detail-description">{product.descriptionDetail}</p>
      <div className="button-group">
        <button className="add-to-cart">Add to Cart</button>
        <button className="back-button" onClick={() => navigate(-1)}>Back to Shop</button>
      </div>
    </div>
  </div>
  <Footer/>
  </>
  );
}

export default ProductDetails;
